
import React from 'react'
import { Alert, AlertProps } from 'antd'

interface CustomAlertProps extends AlertProps {
  message: string,
  type: 'success' | 'info' | 'warning' | 'error',
  showIcon?: boolean,
  closable?: boolean
  addRadius100?: boolean
}

const CustomAlert: React.FC<CustomAlertProps> = (props) => {
  const { message, type, showIcon, closable, addRadius100 = true, ...restProps } = props

  return (
    <Alert
      message={message}
      type={type}
      showIcon={showIcon}
      closable={closable}
      className={addRadius100 ? 'radius-100' : 'radius-10'}
      {...restProps}
    />
  )
}

export default CustomAlert
